export type FilterTab = 'all' | 'countries' | 'events' | 'admissions' | 'travel';

export const FILTER_TABS: FilterTab[] = ['all', 'countries', 'events', 'admissions', 'travel'];

/** i18n phrase keys for filter tab labels */
export const FILTER_TAB_LABELS: Record<FilterTab, string> = {
  all: 'ui.search.filter_all',
  countries: 'ui.search.filter_countries',
  events: 'ui.search.filter_events',
  admissions: 'ui.search.filter_admissions',
  travel: 'ui.search.filter_travel',
};

/** Emoji icons for each page type (used in result cards) */
export const PAGE_TYPE_ICONS: Record<string, string> = {
  country: '\u{1F30D}',
  city: '\u{1F3D9}\uFE0F',
  university: '\u{1F393}',
  'month-hub': '\u{1F4C5}',
  'type-hub': '\u{1F4CB}',
  'religion-hub': '\u{1F54C}',
  'nature-hub': '\u{1F33F}',
  'university-hub': '\u{1F3EB}',
  'long-weekend': '\u{1F3D6}\uFE0F',
  'country-religion': '\u{1F64F}',
  'country-nature': '\u{1F33F}',
  'country-month': '\u{1F5D3}\uFE0F',
  phenomenon: '\u2728',
  'best-time': '\u{1F324}\uFE0F',
  'festival-index': '\u{1F3AD}',
  'cross-calendar': '\u{1F504}',
  admission: '\u{1F393}',
  'university-admission': '\u{1F3EB}',
  'pathway-comparison': '\u{1F4CA}',
  'admission-calendar': '\u{1F4C6}',
  'scholarship-screener': '\u{1F4B0}',
  'admission-faq': '\u2753',
  'event-detail': '\u{1F4CC}',
};

/** Maps page types to filter tabs (used in search filtering) */
export const FILTER_MAP: Record<Exclude<FilterTab, 'all'>, string[]> = {
  countries: ['country', 'city', 'country-religion', 'country-nature', 'country-month'],
  events: ['event-detail', 'month-hub', 'type-hub', 'religion-hub', 'nature-hub', 'long-weekend', 'university-hub'],
  admissions: ['admission', 'university-admission', 'university', 'pathway-comparison', 'admission-calendar', 'scholarship-screener', 'admission-faq'],
  travel: ['best-time', 'phenomenon', 'festival-index', 'cross-calendar'],
};

/** Display order when grouping results by page type */
export const PAGE_TYPE_ORDER: string[] = [
  'country',
  'city',
  'university',
  'admission',
  'university-admission',
  'pathway-comparison',
  'admission-calendar',
  'scholarship-screener',
  'admission-faq',
  'month-hub',
  'type-hub',
  'religion-hub',
  'nature-hub',
  'university-hub',
  'long-weekend',
  'country-religion',
  'country-nature',
  'phenomenon',
  'best-time',
  'festival-index',
  'cross-calendar',
  'country-month',
  'event-detail',
];

/** i18n phrase keys for page type group headers in results */
export const PAGE_TYPE_GROUP_LABELS: Record<string, string> = {
  country: 'ui.search.cat_countries',
  city: 'ui.search.cat_cities',
  university: 'ui.search.cat_universities',
  'month-hub': 'ui.search.cat_month_hubs',
  'type-hub': 'ui.search.cat_type_hubs',
  'religion-hub': 'ui.search.cat_religion_hubs',
  'nature-hub': 'ui.search.cat_nature_hubs',
  'university-hub': 'ui.search.cat_university_hubs',
  'long-weekend': 'ui.search.cat_long_weekends',
  'country-religion': 'ui.search.cat_country_religion',
  'country-nature': 'ui.search.cat_country_nature',
  'country-month': 'ui.search.cat_country_months',
  phenomenon: 'ui.search.cat_phenomena',
  'best-time': 'ui.search.cat_best_time',
  'festival-index': 'ui.search.cat_festivals',
  'cross-calendar': 'ui.search.cat_cross_calendar',
  admission: 'ui.search.cat_admissions',
  'university-admission': 'ui.search.cat_university_admissions',
  'pathway-comparison': 'ui.search.cat_pathway_comparison',
  'admission-calendar': 'ui.search.cat_admission_calendar',
  'scholarship-screener': 'ui.search.cat_scholarship_screener',
  'admission-faq': 'ui.search.cat_admission_faq',
  'event-detail': 'ui.search.cat_events',
};
